
import { createSlice } from "@reduxjs/toolkit";

let initialCreateServiceRequest = {}
const createServiceRequestSlice = createSlice({
    name: 'createServiceRequest',
    initialState: initialCreateServiceRequest,
    reducers: {
        setCreateServiceRequest: (state, action) => {
            return {
                ...action.payload
            }
        },
        resetCreateServiceRequest: () => {
            return initialCreateServiceRequest
        }
    },
});

export const { setCreateServiceRequest, resetCreateServiceRequest } = createServiceRequestSlice.actions;
export default createServiceRequestSlice.reducer;